(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-feature-blocks"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('zan-product-features')) return;

  customElements.define(
    'zan-product-features',
    class extends HTMLElement {
      connectedCallback() {
        const targets = this.querySelectorAll('[data-zan-pf-anim]');
        if (!targets.length) return;

        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce) {
          targets.forEach((el) => el.classList.add('is-inview'));
          return;
        }

        this.classList.add('is-ready');

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-inview');
              observer.unobserve(entry.target);
            });
          },
          { threshold: 0.18, rootMargin: '0px 0px -8% 0px' }
        );

        targets.forEach((el) => observer.observe(el));
      }
    }
  );
})();

  } catch(e) { console.error(e); }
})();
})();
